import { PLACY_LANDING_SRC } from '../components/OffizzBrandMark';
import { useI18n } from '../i18n';
import styles from './SessionSplashScreen.module.css';

export type SessionSplashScreenProps = {
  progress: number;
  exiting?: boolean;
};

export function SessionSplashScreen({ progress, exiting = false }: SessionSplashScreenProps) {
  const { t } = useI18n();
  const clamped = Math.max(0, Math.min(100, progress));

  return (
    <div
      className={`${styles.root}${exiting ? ` ${styles.rootExiting}` : ''}`}
      role="status"
      aria-live="polite"
      aria-busy={!exiting}
    >
      <div className={styles.stage}>
        <img
          src={PLACY_LANDING_SRC}
          alt={t('splash.brandAlt')}
          className={styles.landing}
          draggable={false}
        />
      </div>
      <div className={styles.footer}>
        <p className={styles.progressLabel}>{t('splash.progress', { percent: String(clamped) })}</p>
        <div className={styles.progressTrack} aria-hidden>
          <div className={styles.progressFill} style={{ width: `${clamped}%` }} />
        </div>
      </div>
    </div>
  );
}
